"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    optionLabel: function() {
        return optionLabel;
    },
    optionSearchText: function() {
        return optionSearchText;
    }
});
const optionLabel = function(option) {
    let showFacade = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (option == null) {
        return "";
    }
    if (typeof option.label === "string") {
        return option.label;
    }
    if (!showFacade || option.label.facadeElement == null) {
        return option.label.element;
    }
    return option.label.facadeElement;
};
const optionSearchText = (option)=>{
    if (option == null) {
        return "";
    }
    return typeof option.label === "string" ? option.label : option.label.searchText;
};

//# sourceMappingURL=Option.js.map